/*
 * GMAN custom sections: shared helpers + section controllers.
 * Used by: gman-pack-builder, gman-vertical-gallery, gman-color-wall.
 * Variant data is rendered by Liquid as JSON; this file resolves Color + Size
 * selections to the real Shopify variant ID and adds it to the cart.
 */
(function () {
  if (window.GMAN && window.GMAN.__ready) return;
  /* UI text: window.GMAN_T comes from snippets/gman-i18n.liquid (locale keys gman.js.*). The English fallback keeps the store working if that snippet is missing. */
  function T(k, en, vars) {
    var s = window.GMAN_T && window.GMAN_T[k] != null ? window.GMAN_T[k] : en;
    if (vars) Object.keys(vars).forEach(function (v) { s = s.split('{' + v + '}').join(vars[v]); });
    return s;
  }
  function pickLabel(ph) {
    return /size|talla/.test(ph) ? T('pick_size', 'Pick a size') : /colo/.test(ph) ? T('pick_color', 'Pick a color') : T('pick_option', 'Pick a {option}', { option: ph });
  }

  /* ---------- Size normalization ----------
   * GMAN products spell sizes differently (S / SM, M / MD, 2X / 2XL, "SM (30-32)").
   * Everything is mapped to one canonical label so one size pick works across products. */
  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  var SIZE_ALIASES = {
    XS: 'XS', XSM: 'XS', XSMALL: 'XS',
    S: 'S', SM: 'S', SMALL: 'S',
    M: 'M', MD: 'M', MED: 'M', MEDIUM: 'M',
    L: 'L', LG: 'L', LARGE: 'L',
    XL: 'XL', XLG: 'XL', XLARGE: 'XL',
    '2X': '2XL', '2XL': '2XL', XXL: '2XL',
    '3X': '3XL', '3XL': '3XL', XXXL: '3XL',
    '4X': '4XL', '4XL': '4XL',
    '5X': '5XL', '5XL': '5XL',
    '6X': '6XL', '6XL': '6XL'
  };

  function canonSize(raw) {
    if (raw == null) return '';
    var s = String(raw).toUpperCase().replace(/\(.*?\)/g, '').replace(/[\s\-_.]/g, '');
    return SIZE_ALIASES[s] || String(raw).trim();
  }

  function sizeRank(label) {
    var i = SIZE_ORDER.indexOf(label);
    return i === -1 ? 99 : i;
  }

  function findOptionIndex(options, keyword) {
    for (var i = 0; i < options.length; i++) {
      if (String(options[i]).toLowerCase().indexOf(keyword) !== -1) return i;
    }
    return -1;
  }

  /* Shape one product's JSON into { colorIdx, sizeIdx, variants[] with color + size } */
  function indexProduct(p) {
    var colorIdx = findOptionIndex(p.options, 'colo');
    var sizeIdx = findOptionIndex(p.options, 'size'); if (sizeIdx === -1) sizeIdx = findOptionIndex(p.options, 'talla');
    p.colorIdx = colorIdx;
    p.sizeIdx = sizeIdx;
    p.variants.forEach(function (v) {
      v.color = colorIdx > -1 ? v.options[colorIdx] : p.title;
      v.size = sizeIdx > -1 ? canonSize(v.options[sizeIdx]) : 'One size';
      v.rawSize = sizeIdx > -1 ? v.options[sizeIdx] : 'One size';
    });
    return p;
  }

  function readJSON(el) {
    try { return JSON.parse(el.textContent); } catch (e) { console.error('[GMAN] bad JSON', e); return null; }
  }

  function money(cents) {
    var v = (cents || 0) / 100;
    return '$' + v.toFixed(2);
  }

  /* ---------- Cart ----------
   * Posts to /cart/add.js and asks for the theme's cart drawer sections back,
   * so Abode's <cart-notification> drawer opens with the new items. */
  function addItems(items) {
    var drawer = document.querySelector('cart-notification');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || T('could_not_add_cart', 'Could not add to cart'));
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gman-sections', cartData: res });
        }
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
        return res;
      });
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = !!busy;
    btn.classList.toggle('is-loading', !!busy);
  }

  function showError(root, msg) {
    var el = root.querySelector('[data-gman-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  /* ======================================================================
   * 1. PACK BUILDER
   * ==================================================================== */
  function PackBuilder(root) {
    var data = readJSON(root.querySelector('[data-gman-products]'));
    if (!data) return;
    var cfg = readJSON(root.querySelector('[data-gman-config]')) || {};
    var products = data.map(indexProduct);
    var maxPacks = cfg.maxPacks || 8;
    var packs = []; // [{ p: productIndex, color: 'Burgundy' }]
    var cartCents = 0;
    function refreshCart() {
      fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartCents = c.total_price || 0; render(); })
        .catch(function () {});
    }
    document.addEventListener('cart:refresh', refreshCart);
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'gman-sections') refreshCart(); });
    }

    // Union of canonical sizes across all products, in size order
    var sizeSet = {};
    products.forEach(function (p) { p.variants.forEach(function (v) { sizeSet[v.size] = true; }); });
    delete sizeSet['One size'];
    var sizes = Object.keys(sizeSet).sort(function (a, b) { return sizeRank(a) - sizeRank(b); });
    var size = sizes.indexOf(cfg.defaultSize) > -1 ? cfg.defaultSize : sizes[Math.min(3, sizes.length - 1)];

    var sizeWrap = root.querySelector('[data-sizes]');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-tile]'));
    var slotWrap = root.querySelector('[data-slots]');
    var emptyEl = root.querySelector('[data-empty]');
    var cta = root.querySelector('[data-cta]');

    function variantFor(pi, color, sz) {
      var p = products[pi];
      var fallback = null;
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (v.color !== color) continue;
        if (p.sizeIdx === -1) {
          // one-size items (beanies, socks): any size pick works, use the first in-stock variant
          if (v.available) return v;
          if (!fallback) fallback = v;
        } else if (v.size === sz) return v;
      }
      return fallback;
    }

    // Size pills
    sizeWrap.innerHTML = '';
    sizes.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gman-pill';
      b.textContent = s;
      b.setAttribute('aria-pressed', s === size ? 'true' : 'false');
      b.addEventListener('click', function () { size = s; render(); });
      sizeWrap.appendChild(b);
    });

    // product-card layout: swatches retarget the card's Add button to the picked color
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-swatch]'));
    root.querySelectorAll('[data-card]').forEach(function (card) {
      var add = card.querySelector('[data-tile]');
      var img = card.querySelector('[data-card-img]');
      var colorLabel = card.querySelector('[data-card-color]');
      card.querySelectorAll('[data-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          card.querySelectorAll('[data-swatch]').forEach(function (x) { x.setAttribute('aria-pressed', x === sw ? 'true' : 'false'); });
          add.dataset.color = sw.dataset.color;
          add.dataset.hex = sw.dataset.hex || '';
          add.dataset.label = sw.dataset.label || sw.dataset.color;
          if (sw.dataset.img) add.dataset.img = sw.dataset.img;
          if (img && sw.dataset.imgLg) img.src = sw.dataset.imgLg;
          if (colorLabel) colorLabel.textContent = sw.dataset.color;
          render();
        });
      });
    });

    tiles.forEach(function (t) {
      t.addEventListener('click', function () {
        if (packs.length >= maxPacks || t.disabled) return;
        packs.push({ p: Number(t.dataset.p), color: t.dataset.color, label: t.dataset.label || t.dataset.color, hex: t.dataset.hex, img: t.dataset.img });
        bump = true;
        render();
      });
    });

    function render() {
      // size pills state
      Array.prototype.forEach.call(sizeWrap.children, function (b) {
        b.setAttribute('aria-pressed', b.textContent === size ? 'true' : 'false');
      });
      root.querySelector('[data-size-label]').textContent = size;

      // tile availability + counts for this size
      tiles.forEach(function (t) {
        var v = variantFor(Number(t.dataset.p), t.dataset.color, size);
        var ok = !!(v && v.available);
        var count = packs.filter(function (pk) { return pk.p === Number(t.dataset.p) && pk.color === t.dataset.color; }).length;
        t.disabled = !ok;
        t.classList.toggle('is-in-pack', count > 0);
        t.querySelector('[data-count]').textContent = !ok ? T('sold_out_in', 'Sold out in {size}', { size: size }) : count ? (t.classList.contains('gman-pb__add') ? T('add_another', 'Add another ({n} added)', { n: count }) : T('in_pack', '{n} in pack', { n: count })) : T('add_plus', '+ Add');
      });
      swatches.forEach(function (sw) {
        var card = sw.closest('[data-card]');
        var add = card && card.querySelector('[data-tile]');
        if (!add) return;
        var v = variantFor(Number(add.dataset.p), sw.dataset.color, size);
        sw.classList.toggle('is-unavailable', !(v && v.available));
      });

      // slots
      slotWrap.querySelectorAll('[data-slot]').forEach(function (n) { n.remove(); });
      var subtotal = 0, units = 0, unavailable = 0, lines = {};
      packs.forEach(function (pk, i) {
        var v = variantFor(pk.p, pk.color, size);
        var ok = !!(v && v.available);
        if (ok) {
          subtotal += v.price;
          units += products[pk.p].unitsPerPack;
          lines[v.id] = (lines[v.id] || 0) + 1;
        } else unavailable++;
        var slot = document.createElement('div');
        slot.className = 'gman-slot' + (ok ? '' : ' is-unavailable');
        slot.setAttribute('data-slot', '');
        slot.innerHTML =
          (pk.img ? '<img src="' + pk.img + '" alt="" loading="lazy" width="120" height="120">' : '<span class="gman-slot__swatch" style="background:' + (pk.hex || '#ccc') + '"></span>') +
          '<span class="gman-slot__name"></span>' +
          '<button type="button" class="gman-slot__remove" aria-label="Remove">&times;</button>';
        slot.querySelector('.gman-slot__name').textContent = pk.label + (ok ? '' : ' (not in ' + size + ')');
        slot.querySelector('button').addEventListener('click', function () { packs.splice(i, 1); render(); });
        slotWrap.appendChild(slot);
      });
      emptyEl.hidden = packs.length > 0;

      // totals + thresholds
      var ship = cfg.freeShipCents, disc = cfg.discountCents, pct = cfg.discountPct || 0;
      // thresholds count what is already in the cart plus this box, like checkout does
      var progress = subtotal + cartCents;
      var hasDisc = cfg.showDiscount && disc && progress >= disc && subtotal > 0;
      var discount = hasDisc ? Math.round(subtotal * pct / 100) : 0;
      var total = subtotal - discount;
      var barMax = cfg.showDiscount && disc ? disc : ship || 1;
      root.querySelector('[data-bar]').style.width = Math.min(progress / barMax, 1) * 100 + '%';
      var avgPack = subtotal && packs.length ? subtotal / Math.max(packs.length - unavailable, 1) : (products[0] && products[0].variants[0] ? products[0].variants[0].price : 1450);
      var noun = cfg.progressNoun === 'item' || cfg.progressNoun === 'color' ? cfg.progressNoun : (cfg.layout === 'products' ? 'item' : 'color');
      var nounFor = function (k) { return k > 1 ? T(noun + 's', noun + 's') : T(noun, noun); };
      var msg;
      if (!progress) msg = cfg.msgStart;
      else if (ship && progress < ship) { var n = Math.ceil((ship - progress) / avgPack); msg = T('ship_more', 'Add {n} more {noun} to unlock free shipping.', { n: n, noun: nounFor(n) }); }
      else if (cfg.showDiscount && disc && progress < disc) { var m = Math.ceil((disc - progress) / avgPack); msg = T('ship_unlocked_more', 'Free shipping unlocked. {n} more {noun} for {pct}% off.', { n: m, noun: nounFor(m), pct: pct }); }
      else msg = cfg.showDiscount && disc ? T('ship_disc_unlocked', 'Free shipping + {pct}% off unlocked.', { pct: pct }) : T('ship_unlocked', 'Free shipping unlocked.');
      var inCart = root.querySelector('[data-incart]');
      if (inCart) {
        inCart.hidden = !cartCents;
        inCart.querySelector('[data-incart-total]').textContent = money(cartCents);
      }
      root.querySelector('[data-msg]').textContent = msg;
      root.querySelector('[data-units]').textContent = units;
      root.querySelector('[data-subtotal]').textContent = money(subtotal);
      root.querySelector('[data-discount-row]').hidden = !hasDisc;
      root.querySelector('[data-discount]').textContent = '-' + money(discount);
      root.querySelector('[data-total]').textContent = money(total);
      root.querySelector('[data-per]').textContent = units ? money(Math.round(total / units)) + ' / ' + (cfg.unitSingular || 'shirt') : '';

      var addable = Object.keys(lines);
      cta.disabled = !addable.length;
      cta.querySelector('[data-label]').textContent = addable.length ? T('add_units', 'Add {n} {unit} to cart', { n: units, unit: units === 1 ? (cfg.unitSingular || 'shirt') : (cfg.unitPlural || 'shirts') }) : cfg.ctaEmpty;
      cta._lines = lines;

      // mobile floating bar mirrors the panel
      if (float) {
        float.querySelector('[data-float-units]').textContent = units;
        float.querySelector('[data-float-total]').textContent = money(total);
        float.querySelector('[data-float-msg]').textContent = msg;
        float.querySelector('[data-float-bar]').style.width = Math.min(subtotal / barMax, 1) * 100 + '%';
        floatCta.disabled = !addable.length;
        updateFloat();
        if (bump) {
          float.classList.remove('is-bump');
          void float.offsetWidth;
          float.classList.add('is-bump');
          bump = false;
        }
      }
    }

    var float = root.querySelector('[data-float]');
    var floatCta = float && float.querySelector('[data-float-cta]');
    var panel = root.querySelector('.gman-pb__panel');
    var panelInView = false, bump = false;
    function updateFloat() {
      if (!float) return;
      float.hidden = !(packs.length > 0 && !panelInView);
    }
    if (float) {
      if ('IntersectionObserver' in window && panel) {
        new IntersectionObserver(function (entries) {
          panelInView = entries[0].isIntersecting;
          updateFloat();
        }, { threshold: 0.25 }).observe(panel);
      }
      float.querySelector('[data-float-view]').addEventListener('click', function () {
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      floatCta.addEventListener('click', function () { if (!cta.disabled) cta.click(); });
    }

    cta.addEventListener('click', function () {
      var lines = cta._lines || {};
      var items = Object.keys(lines).map(function (id) { return { id: Number(id), quantity: lines[id] }; });
      if (!items.length) return;
      showError(root, '');
      setBusy(cta, true);
      addItems(items)
        .then(function () { packs = []; refreshCart(); })
        .catch(function (e) { showError(root, e.message); })
        .finally(function () { setBusy(cta, false); render(); });
    });

    render();
    refreshCart();
  }

  /* ======================================================================
   * 2. VERTICAL GALLERY PRODUCT
   * ==================================================================== */
  function VerticalGallery(root) {
    var product = readJSON(root.querySelector('[data-gman-product]'));
    if (!product) return;
    indexProduct(product);
    var scroller = root.querySelector('[data-scroller]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var counter = root.querySelector('[data-counter]');
    var form = root.querySelector('[data-form]');
    var idInput = form.querySelector('[name="id"]');
    var atc = form.querySelector('[data-atc]');
    var qty = form.querySelector('[name="quantity"]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-group]'));
    var upp = product.unitsPerPack || 1;

    var current = product.variants.filter(function (v) { return v.id === product.selectedId; })[0] || product.variants[0];
    var selected = current.options.slice();

    /* gallery: active slide tracking */
    function setActive(i) {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (counter) counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
    }
    if ('IntersectionObserver' in window && slides.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) setActive(slides.indexOf(e.target)); });
      }, { root: scroller, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    function goTo(i) {
      var s = slides[i];
      if (!s) return;
      var horizontal = scroller.scrollWidth > scroller.clientWidth + 4;
      scroller.scrollTo(horizontal ? { left: s.offsetLeft, behavior: 'smooth' } : { top: s.offsetTop, behavior: 'smooth' });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });

    function variantFromOptions(opts) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0] || null;
    }

    /* mark option values that have no available variant given the other picks */
    function refreshAvailability() {
      groups.forEach(function (g) {
        var idx = Number(g.dataset.index);
        g.querySelectorAll('[data-value]').forEach(function (b) {
          var test = selected.slice();
          test[idx] = b.dataset.value;
          var v = variantFromOptions(test);
          b.classList.toggle('is-unavailable', !v || !v.available);
          b.setAttribute('aria-pressed', b.dataset.value === selected[idx] ? 'true' : 'false');
        });
        var lbl = g.querySelector('[data-selected-label]');
        if (lbl) lbl.textContent = selected[idx];
      });
    }

    function update(colorChanged) {
      var v = variantFromOptions(selected);
      refreshAvailability();
      if (!v) {
        atc.disabled = true;
        atc.querySelector('[data-label]').textContent = T('unavailable', 'Unavailable');
        return;
      }
      current = v;
      idInput.value = v.id;
      root.querySelector('[data-price]').textContent = money(v.price);
      var cmp = root.querySelector('[data-compare]');
      if (cmp) { cmp.hidden = !(v.compare_at_price > v.price); cmp.textContent = money(v.compare_at_price); }
      var per = root.querySelector('[data-per-unit]');
      if (per) per.textContent = upp > 1 ? money(Math.round(v.price / upp)) + ' ' + (per.dataset.unit || 'per shirt') : '';
      atc.disabled = !v.available;
      atc.querySelector('[data-label]').innerHTML = v.available ? T('add_to_cart', 'Add to cart') + '<span class="gman-btn__price"> · ' + money(v.price) + '</span>' : T('sold_out', 'Sold out');
      if (product.updateUrl && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
      // jump the gallery to this color's image
      if (colorChanged && v.featured_media_id) {
        var target = slides.findIndex(function (s) { return Number(s.dataset.mediaId) === v.featured_media_id; });
        if (target > -1) goTo(target);
      }
    }

    groups.forEach(function (g) {
      var idx = Number(g.dataset.index);
      g.querySelectorAll('[data-value]').forEach(function (b) {
        b.addEventListener('click', function () {
          selected[idx] = b.dataset.value;
          // if this combo does not exist, keep the pick and snap the other options to the first available match
          if (!variantFromOptions(selected) || !variantFromOptions(selected).available) {
            var alt = product.variants.filter(function (v) { return v.available && v.options[idx] === b.dataset.value; })[0];
            if (alt && idx === product.colorIdx) selected = alt.options.slice();
          }
          update(idx === product.colorIdx);
        });
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      showError(root, '');
      setBusy(atc, true);
      // carry line item properties from app blocks (e.g. Easify Product Options) inside the form
      var item = { id: Number(idInput.value), quantity: Math.max(1, Number(qty && qty.value) || 1) };
      var props = {};
      new FormData(form).forEach(function (val, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && val !== '' && typeof val === 'string') props[m[1]] = val;
      });
      if (Object.keys(props).length) item.properties = props;
      addItems([item])
        .catch(function (err) { showError(root, err.message); })
        .finally(function () { setBusy(atc, false); update(false); });
    });

    var minus = form.querySelector('[data-qty-minus]'), plus = form.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (Number(qty.value) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { qty.value = (Number(qty.value) || 1) + 1; });

    setActive(0);
    update(false);
  }

  /* ======================================================================
   * 3. COLOR WALL
   * ==================================================================== */
  function ColorWall(root) {
    var data = readJSON(root.querySelector('[data-gman-products]'));
    if (!data) return;
    var products = data.map(indexProduct);
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-tile]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var bar = root.querySelector('[data-bar]');
    var sizeWrap = root.querySelector('[data-sizes]');
    var add = root.querySelector('[data-add]');
    var sel = null, size = null;

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.dataset.filter;
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        tiles.forEach(function (t) { t.classList.toggle('is-dimmed', f !== 'all' && t.dataset.p !== f); });
      });
    });

    function variantsFor(pi, color) {
      return products[pi].variants.filter(function (v) { return v.color === color; })
        .sort(function (a, b) { return sizeRank(a.size) - sizeRank(b.size); });
    }

    function select(t) {
      tiles.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
      var pi = Number(t.dataset.p);
      var vs = variantsFor(pi, t.dataset.color);
      sel = { p: pi, color: t.dataset.color, variants: vs };
      var keep = vs.filter(function (v) { return v.size === size && v.available; })[0];
      size = keep ? size : ((vs.filter(function (v) { return v.available; })[0] || vs[0] || {}).size || null);
      bar.querySelector('[data-bar-name]').textContent = t.dataset.color + ' · ' + products[pi].title;
      var sw = bar.querySelector('[data-bar-swatch]');
      // prefer the real color swatch; fall back to the variant photo only when no hex exists
      sw.style.backgroundImage = !t.dataset.hex && t.dataset.img ? 'url(' + t.dataset.img + ')' : 'none';
      sw.style.backgroundColor = t.dataset.hex || '#cccccc';
      bar.querySelector('[data-bar-link]').href = products[pi].url + (vs[0] ? '?variant=' + vs[0].id : '');
      renderSizes();
    }

    function renderSizes() {
      sizeWrap.innerHTML = '';
      if (!sel) return;
      sel.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gman-pill' + (v.available ? '' : ' is-unavailable');
        b.textContent = v.size;
        b.disabled = !v.available;
        b.setAttribute('aria-pressed', v.size === size ? 'true' : 'false');
        b.addEventListener('click', function () { size = v.size; renderSizes(); });
        sizeWrap.appendChild(b);
      });
      var v = sel.variants.filter(function (x) { return x.size === size; })[0];
      var upp = products[sel.p].unitsPerPack || 1;
      bar.querySelector('[data-bar-price]').textContent = v
        ? money(v.price) + (upp > 1 ? ' · ' + money(Math.round(v.price / upp)) + ' ' + T('per_shirt', 'per shirt') : '')
        : '';
      add.disabled = !(v && v.available);
      add._variant = v;
      add.querySelector('[data-label]').textContent = v && v.available ? T('quick_add', 'Quick add · {size}', { size: size }) : T('sold_out', 'Sold out');
    }

    tiles.forEach(function (t) {
      t.addEventListener('click', function () { select(t); });
    });

    add.addEventListener('click', function () {
      var v = add._variant;
      if (!v) return;
      showError(root, '');
      setBusy(add, true);
      addItems([{ id: v.id, quantity: 1 }])
        .catch(function (e) { showError(root, e.message); })
        .finally(function () { setBusy(add, false); renderSizes(); });
    });

    // open on the color with the most sizes in stock, so the size bar doesn't start mostly sold out
    function inStock(t) {
      return variantsFor(Number(t.dataset.p), t.dataset.color).filter(function (v) { return v.available; }).length;
    }
    var first = tiles.reduce(function (best, t) { return !best || inStock(t) > inStock(best) ? t : best; }, null) || tiles[0];

    // phones: show the first N colors plus a "See all" button (CSS only hides them under 750px)
    var limit = parseInt(root.dataset.mobileLimit, 10) || 0;
    var grid = root.querySelector('.gman-cw__grid');
    if (limit && grid && tiles.length > limit) {
      var shown = tiles.slice(0, limit);
      if (first && shown.indexOf(first) === -1) shown[limit - 1] = first; // never hide the selected color
      tiles.forEach(function (t) { if (shown.indexOf(t) === -1) t.setAttribute('data-extra', ''); });
      grid.classList.add('is-collapsed');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'gman-cw__more';
      more.textContent = T('see_all_colors', 'See all {n} colors', { n: tiles.length });
      more.addEventListener('click', expand);
      grid.insertAdjacentElement('afterend', more);
      chips.forEach(function (c) { c.addEventListener('click', expand); });
    }
    function expand() {
      if (!grid || !grid.classList.contains('is-collapsed')) return;
      grid.classList.remove('is-collapsed');
      if (more && more.parentNode) more.parentNode.removeChild(more);
    }
    if (first) select(first);
  }

  /* ======================================================================
   * 4. SEASON SHELF (homepage tabs, pick + add on each card, 2-product kit)
   * ==================================================================== */

  // ?gman_date=12-05 previews another date (Season Shelf and Calendar Band)
  function gmanToday() {
    var m = /[?&]gman_date=(\d{1,2})-(\d{1,2})/.exec(window.location.search || '');
    var now = new Date();
    if (m) return new Date(now.getFullYear(), parseInt(m[1], 10) - 1, parseInt(m[2], 10), 12);
    return now;
  }

  function SeasonShelf(root) {
    var data = readJSON(root.querySelector('[data-gman-shelf]'));
    if (!data) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));

    data.tabs.forEach(function (t) {
      t.products = (t.products || []).map(indexProduct);
      if (t.kit) t.kit = t.kit.map(indexProduct);
    });

    /* ---------- tabs ---------- */
    function setTab(i, focus) {
      tabs.forEach(function (b) {
        var on = Number(b.dataset.tab) === i;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        if (on && focus) b.focus();
      });
      root.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = Number(p.dataset.panel) !== i; });
      root.querySelectorAll('[data-intro]').forEach(function (p) { p.hidden = Number(p.dataset.intro) !== i; });
    }
    tabs.forEach(function (b) {
      b.addEventListener('click', function () { setTab(Number(b.dataset.tab)); });
      b.addEventListener('keydown', function (e) {
        var d = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (!d) return;
        e.preventDefault();
        var i = (tabs.indexOf(b) + d + tabs.length) % tabs.length;
        setTab(Number(tabs[i].dataset.tab), true);
      });
    });
    // the cached page may be from another day: re-pick the in-season tab by the visitor's date
    if (!(window.Shopify && window.Shopify.designMode)) {
      var month = String(gmanToday().getMonth() + 1);
      for (var ti = 0; ti < data.tabs.length; ti++) {
        if (String(data.tabs[ti].months || '').split(',').indexOf(month) > -1) { setTab(ti); break; }
      }
    }

    function flash(el, text) {
      if (!el) return;
      el.textContent = text || '';
      clearTimeout(el.__t);
      if (text) el.__t = setTimeout(function () { el.textContent = ''; }, 4000);
    }

    /* ---------- product cards: pick color + size on the card, then Add ---------- */
    root.querySelectorAll('[data-card]').forEach(function (card) {
      var k = card.dataset.card.split('-');
      var tab = data.tabs[Number(k[0])];
      var p = tab && tab.products[Number(k[1])];
      var btn = card.querySelector('[data-add]');
      if (!p || !btn) return;
      var label = btn.querySelector('[data-label]');
      var msg = card.querySelector('[data-msg]');
      var qty = Math.max(1, parseInt(card.dataset.qty, 10) || 1); // e.g. 2 for a buy-1-get-1 deal
      var swatches = Array.prototype.slice.call(card.querySelectorAll('.gman-ss__sw'));
      var selects = Array.prototype.slice.call(card.querySelectorAll('select[data-opt]'));
      var sel = {};

      var cardImg = card.querySelector('.gman-ss__media img');
      // show the picked color's photo on the card
      function showColor(s) {
        if (!cardImg || !s.dataset.img) return;
        if (s.dataset.srcset) cardImg.srcset = s.dataset.srcset;
        cardImg.src = s.dataset.img;
      }

      // preselect: the color that matches the card photo if it has stock, else the first color with stock
      if (swatches.length) {
        var ci = Number(swatches[0].dataset.opt);
        var inStock = swatches.filter(function (s) {
          return p.variants.some(function (v) { return v.available && v.options[ci] === s.dataset.value; });
        });
        var featured = inStock.filter(function (s) { return s.hasAttribute('data-featured'); })[0];
        var first = featured || inStock[0] || swatches[0];
        sel[ci] = first.dataset.value;
        if (!first.hasAttribute('data-featured')) showColor(first);
      }
      selects.forEach(function (s) { if (s.options.length === 2) { s.selectedIndex = 1; sel[Number(s.dataset.opt)] = s.value; } });

      function matches(v, picks) {
        for (var oi = 0; oi < p.options.length; oi++) {
          if (picks[oi] != null && picks[oi] !== '' && v.options[oi] !== picks[oi]) return false;
        }
        return true;
      }
      function current() {
        for (var oi = 0; oi < p.options.length; oi++) if (sel[oi] == null || sel[oi] === '') return null;
        for (var i = 0; i < p.variants.length; i++) if (matches(p.variants[i], sel)) return p.variants[i];
        return null;
      }
      function render() {
        swatches.forEach(function (s) {
          var oi = Number(s.dataset.opt);
          var on = sel[oi] === s.dataset.value;
          var any = p.variants.some(function (v) { return v.available && v.options[oi] === s.dataset.value; });
          s.setAttribute('aria-checked', on ? 'true' : 'false');
          s.setAttribute('aria-label', s.dataset.value + (any ? '' : ', sold out'));
          s.classList.toggle('is-sold', !any);
          s.tabIndex = on ? 0 : -1;
        });
        // mark sold-out values given the other picks
        selects.forEach(function (s) {
          var oi = Number(s.dataset.opt);
          Array.prototype.forEach.call(s.options, function (o) {
            if (!o.value) return;
            var trial = {}; Object.keys(sel).forEach(function (x) { trial[x] = sel[x]; }); trial[oi] = o.value;
            var ok = p.variants.some(function (v) { return v.available && matches(v, trial); });
            o.disabled = !ok;
            o.textContent = o.value + (ok ? '' : T('sold_out_suffix', ' (sold out)'));
          });
        });
        if (swatches.length && !swatches.some(function (s) { return s.tabIndex === 0; })) swatches[0].tabIndex = 0;
        var v = current();
        btn.disabled = !(v && v.available);
        if (!v) {
          var missing = selects.filter(function (s) { return !s.value; })[0];
          label.textContent = missing ? pickLabel((missing.options[0].textContent || 'size').toLowerCase()) : T('pick_color', 'Pick a color');
        } else if (!v.available) {
          label.textContent = T('sold_out', 'Sold out');
        } else {
          label.textContent = qty > 1 ? T('add_qty_pay', 'Add {n}, pay {price}', { n: qty, price: money(v.price) }) : T('add_price', 'Add, {price}', { price: money(v.price) });
        }
      }
      swatches.forEach(function (s, i) {
        s.addEventListener('click', function () { sel[Number(s.dataset.opt)] = s.dataset.value; showColor(s); render(); });
        s.addEventListener('keydown', function (e) {
          var d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
          if (!d) return;
          e.preventDefault();
          var n = swatches[(i + d + swatches.length) % swatches.length];
          n.focus(); n.click();
        });
      });
      selects.forEach(function (s) {
        s.addEventListener('change', function () { sel[Number(s.dataset.opt)] = s.value; render(); });
      });
      btn.addEventListener('click', function () {
        var v = current();
        if (!v || !v.available) return;
        setBusy(btn, true);
        flash(msg, '');
        addItems([{ id: v.id, quantity: qty }])
          .then(function () {
            flash(msg, T('added', 'Added to cart.'));
            track('gman_shelf_add', { kind: 'one', product_id: p.id, variant_id: v.id, value: v.price / 100 });
          })
          .catch(function (e) { flash(msg, e.message || T('could_not_add_retry', 'Could not add. Try again.')); })
          .finally(function () { setBusy(btn, false); render(); });
      });
      render();
    });

    /* ---------- bundle: one color + size for both products ---------- */
    root.querySelectorAll('[data-kit]').forEach(function (box) {
      var t = data.tabs[Number(box.dataset.kit)];
      if (!t || !t.kit || t.kit.length < 2) return;
      var a = t.kit[0], b = t.kit[1];
      var colorSel = box.querySelector('[data-kit-opt="color"]');
      var sizeSel = box.querySelector('[data-kit-opt="size"]');
      var btn = box.querySelector('[data-kit-add]');
      var label = btn.querySelector('[data-label]');
      var msg = box.querySelector('[data-msg]');
      var cta = box.dataset.cta || 'Add both';
      function uniq(arr) { var o = []; arr.forEach(function (x) { if (o.indexOf(x) === -1) o.push(x); }); return o; }
      var useColor = a.colorIdx > -1 && b.colorIdx > -1;
      var colors = useColor ? uniq(a.variants.map(function (v) { return v.color; })).filter(function (c) {
        return b.variants.some(function (v) { return v.color === c; });
      }) : [];
      var sizesA = uniq(a.variants.map(function (v) { return v.size; }));
      var sizes = uniq(b.variants.map(function (v) { return v.size; })).filter(function (s) { return sizesA.indexOf(s) > -1; })
        .sort(function (x, y) { return sizeRank(x) - sizeRank(y); });
      function fill(selEl, values) {
        values.forEach(function (val) { var o = document.createElement('option'); o.value = val; o.textContent = val; selEl.appendChild(o); });
      }
      if (useColor) fill(colorSel, colors); else colorSel.closest('label').hidden = true;
      fill(sizeSel, sizes);
      if (colors.length) colorSel.value = colors[0];
      function part(prod, c, s) {
        for (var i = 0; i < prod.variants.length; i++) {
          var v = prod.variants[i];
          if (useColor && v.color !== c) continue;
          if (v.size === s) return v;
        }
        return null;
      }
      function pair() {
        if (!sizeSel.value || (useColor && !colorSel.value)) return null;
        var va = part(a, colorSel.value, sizeSel.value), vb = part(b, colorSel.value, sizeSel.value);
        return va && vb ? [va, vb] : null;
      }
      function render() {
        Array.prototype.forEach.call(sizeSel.options, function (o) {
          if (!o.value) return;
          var va = part(a, colorSel.value, o.value), vb = part(b, colorSel.value, o.value);
          var ok = !!(va && vb && va.available && vb.available);
          o.disabled = !ok;
          o.textContent = o.value + (ok ? '' : T('sold_out_suffix', ' (sold out)'));
        });
        var vs = pair();
        var ok = vs && vs[0].available && vs[1].available;
        btn.disabled = !ok;
        label.textContent = !vs ? T('pick_size', 'Pick a size') : (ok ? cta + ', ' + money(vs[0].price + vs[1].price) : T('sold_out', 'Sold out'));
      }
      colorSel.addEventListener('change', render);
      sizeSel.addEventListener('change', render);
      btn.addEventListener('click', function () {
        var vs = pair();
        if (!vs) return;
        setBusy(btn, true);
        flash(msg, '');
        addItems(vs.map(function (v) { return { id: v.id, quantity: 1 }; }))
          .then(function () {
            flash(msg, T('both_added', 'Both added to cart.'));
            track('gman_shelf_add', { kind: 'kit', value: (vs[0].price + vs[1].price) / 100, items: 2 });
          })
          .catch(function (e) { flash(msg, e.message || T('could_not_add_retry', 'Could not add. Try again.')); })
          .finally(function () { setBusy(btn, false); render(); });
      });
      render();
    });

    // Bundle links (/#cold-weather-kit): open that bundle's tab and scroll to it.
    // Only on a real click or a first arrival from another page. The # is then cleared
    // from the address bar, so reloading or going Back never jumps the page again.
    function goTo(id, focusIt) {
      var target = id && document.getElementById(id);
      if (!target || !root.contains(target)) return false;
      var panel = target.closest('[data-panel]');
      if (panel) setTab(Number(panel.dataset.panel));
      requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (focusIt) {
          var first = target.querySelector('select, button');
          if (first) first.focus({ preventScroll: true });
        }
      });
      return true;
    }
    function clearHash() {
      if (window.history && history.replaceState) history.replaceState(history.state, '', window.location.pathname + window.location.search);
    }
    function hashId(href) {
      var i = String(href || '').indexOf('#');
      return i > -1 ? decodeURIComponent(String(href).slice(i + 1)) : '';
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
      if (url.pathname !== window.location.pathname) return; // other pages: normal navigation
      var id = hashId(a.getAttribute('href'));
      var target = id && document.getElementById(id);
      if (!target || !root.contains(target)) return;
      e.preventDefault();
      goTo(id, true);
    });
    var landing = hashId(window.location.hash);
    if (landing && document.getElementById(landing) && root.contains(document.getElementById(landing))) {
      var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
      if (nav.type !== 'reload' && nav.type !== 'back_forward') goTo(landing, false);
      clearHash();
    }

    root.__gmanShelf = { setTab: setTab, data: data };
  }

  function track(event, payload) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: event }, payload || {})); } catch (e) {}
  }

  /* ======================================================================
   * 5. CALENDAR BAND (homepage message that changes by date)
   * ==================================================================== */
  // phases carry data-start / data-end as MM-DD; a window may wrap the year (12-26 to 01-31)
  function md(date) { return (date.getMonth() + 1) * 100 + date.getDate(); }
  function parseMD(s) { var m = /^(\d{1,2})-(\d{1,2})$/.exec(String(s || '').trim()); return m ? parseInt(m[1], 10) * 100 + parseInt(m[2], 10) : null; }
  function inWindow(today, start, end) {
    if (start == null || end == null) return false;
    return start <= end ? (today >= start && today <= end) : (today >= start || today <= end);
  }
  function pickPhase(phases, date) {
    var t = md(date), fallback = -1;
    for (var i = 0; i < phases.length; i++) {
      if (inWindow(t, parseMD(phases[i].start), parseMD(phases[i].end))) return i;
      if (phases[i].fallback && fallback === -1) fallback = i;
    }
    return fallback;
  }

  function CalendarBand(root) {
    var phases = Array.prototype.slice.call(root.querySelectorAll('[data-phase]')).map(function (el) {
      return { el: el, start: el.dataset.start, end: el.dataset.end, fallback: el.dataset.fallback === 'true', countdown: el.dataset.countdown };
    });
    if (!phases.length) return;
    var timer = null;

    function show(i) {
      phases.forEach(function (p, j) { p.el.hidden = j !== i; });
      root.hidden = i === -1;
      if (timer) { clearInterval(timer); timer = null; }
      if (i > -1 && phases[i].countdown) startCountdown(phases[i]);
    }

    function startCountdown(p) {
      var end = parseMD(p.countdown);
      var box = p.el.querySelector('[data-countdown]');
      if (!end || !box) return;
      function tick() {
        var now = gmanToday();
        var year = now.getFullYear();
        var target = new Date(year, Math.floor(end / 100) - 1, end % 100, 23, 59, 59);
        if (target < now && now.getMonth() > target.getMonth()) target.setFullYear(year + 1);
        var ms = target - now;
        if (ms <= 0) { box.hidden = true; return; }
        box.hidden = false;
        var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, mi = Math.floor(ms / 6e4) % 60;
        box.querySelector('[data-cd="d"]').textContent = String(d);
        box.querySelector('[data-cd="h"]').textContent = (h < 10 ? '0' : '') + h;
        box.querySelector('[data-cd="m"]').textContent = (mi < 10 ? '0' : '') + mi;
      }
      tick();
      timer = setInterval(tick, 30000);
    }

    if (window.Shopify && window.Shopify.designMode) {
      // theme editor: show the block being edited, else today's phase
      root.addEventListener('shopify:block:select', function (e) {
        var i = phases.map(function (p) { return p.el; }).indexOf(e.target.closest('[data-phase]'));
        if (i > -1) show(i);
      });
    }
    show(pickPhase(phases, gmanToday()));
    root.__gmanBand = { show: show, pick: function (d) { return pickPhase(phases, d); } };
  }

  /* ---------- Category Mosaic: vertical category slider ----------
     Two tiles in view, moves up one tile every N seconds, loops via cloned tiles.
     Pauses on hover/focus, when off screen, when the tab is hidden, and for reduced motion. */
  function CategoryMosaic(root) {
    var viewport = root.querySelector('[data-viewport]');
    var track = root.querySelector('[data-track]');
    if (!viewport || !track) return;
    var originals = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
    var n = originals.length;
    var count = root.querySelector('[data-count]');
    var VISIBLE = 2;
    if (n <= VISIBLE) return;

    // clones for a seamless loop (hidden from screen readers and tab order)
    originals.slice(0, VISIBLE).forEach(function (s) {
      var c = s.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-shopify-editor-block');
      c.querySelectorAll('a, button').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      track.appendChild(c);
    });

    var i = 0, step = 0, timer = null, paused = false, inView = true, moving = false;
    var interval = (parseInt(root.dataset.interval, 10) || 0) * 1000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function measure() {
      root.style.setProperty('--gman-cm-vh', viewport.clientHeight + 'px');
      var all = track.querySelectorAll('[data-slide]');
      step = all.length > 1 ? all[1].offsetTop - all[0].offsetTop : viewport.clientHeight / VISIBLE;
    }
    function place(animate) {
      track.classList.toggle('is-animating', !!animate);
      track.style.transform = 'translate3d(0,' + (-i * step) + 'px,0)';
      if (count) count.textContent = ((i % n) + 1) + ' / ' + n;
      originals.forEach(function (s, k) {
        var shown = k === i % n || k === (i + 1) % n;
        s.setAttribute('aria-hidden', shown ? 'false' : 'true');
        s.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', shown ? '0' : '-1'); });
      });
    }
    function go(to) {
      if (moving) return;
      if (to < 0) { i = n; place(false); void track.offsetHeight; to = n - 1; }
      i = to;
      moving = true;
      place(!reduce);
      if (reduce) settle();
    }
    function settle() {
      moving = false;
      if (i >= n) { i = i - n; place(false); }
    }
    track.addEventListener('transitionend', function (e) { if (e.target === track) settle(); });

    function tick() { if (!paused && inView && !document.hidden) go(i + 1); }
    function start() { stop(); if (interval && !reduce) timer = setInterval(tick, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }, { threshold: 0.25 }).observe(root);
    }
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { measure(); place(false); }, 120); });

    // theme editor: bring the selected block into view and hold
    root.addEventListener('shopify:block:select', function (e) {
      var k = originals.indexOf(e.target.closest('[data-slide]'));
      if (k > -1) { paused = true; moving = false; i = k; place(false); }
    });
    root.addEventListener('shopify:block:deselect', function () { paused = false; });

    measure();
    place(false);
    start();
    root.__gmanMosaic = { go: go, index: function () { return i; }, step: function () { return step; }, settle: settle };
  }

  /* ---------- boot (also re-boots inside the theme editor) ---------- */
  var CONTROLLERS = { 'pack-builder': PackBuilder, 'vertical-gallery': VerticalGallery, 'color-wall': ColorWall, 'season-shelf': SeasonShelf, 'calendar-band': CalendarBand, 'category-mosaic': CategoryMosaic };
  function boot(scope) {
    (scope || document).querySelectorAll('[data-gman-section]').forEach(function (el) {
      if (el.__gmanInit) return;
      el.__gmanInit = true;
      var C = CONTROLLERS[el.dataset.gmanSection];
      if (C) {
        try { C(el); } catch (e) { console.error('[GMAN] section init failed', e); }
      }
    });
  }

  // "#reviews" links (star summary) scroll to the reviews section, whose id Shopify generates per template
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#reviews"]');
    if (!a) return;
    var target = document.getElementById('reviews') || document.querySelector('[id$="__gman_reviews"]');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });

  window.GMAN = { __ready: true, boot: boot, addItems: addItems, canonSize: canonSize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
